import { render, staticRenderFns } from "./composeNewEmail.vue?vue&type=template&id=35f745bd&scoped=true"
import script from "./composeNewEmail.vue?vue&type=script&lang=js"
export * from "./composeNewEmail.vue?vue&type=script&lang=js"
import style0 from "./composeNewEmail.vue?vue&type=style&index=0&id=35f745bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f745bd",
  null
  
)

export default component.exports